if (!customElements.get('rnf-collection-rail')) {
  customElements.define('rnf-collection-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.desktop) return;
      this.desktop = matchMedia('(min-width: 990px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.home = this.hasAttribute('data-rnf-home-rail');
      this.sync = () => this.home || this.desktop.matches ? this.start() : this.stop();
      this.desktop.addEventListener('change', this.sync);
      this.sync();
    }

    start() {
      if (this.grid) return;
      this.grid = this.querySelector('.collection-list');
      if (!this.grid) return;
      this.buttons = [...this.querySelectorAll('[data-rnf-collection-list-step]')];
      this.target = null;
      this.frame = 0;
      this.onScroll = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      this.onManual = () => { this.target = null; };
      this.onClick = event => {
        const button = event.target.closest('[data-rnf-collection-list-step]');
        if (!button || !this.contains(button) || button.disabled) return;
        event.preventDefault();
        this.target = Math.max(0, Math.min(this.max, (this.target ?? Math.abs(this.grid.scrollLeft)) + Number(button.dataset.rnfCollectionListStep) * this.stride));
        this.grid.scrollTo({ left: this.rtl ? -this.target : this.target, behavior: this.reduced.matches ? 'instant' : 'smooth' });
      };
      this.addEventListener('click', this.onClick);
      this.grid.addEventListener('scroll', this.onScroll, { passive: true });
      this.grid.addEventListener('pointerdown', this.onManual, { passive: true });
      this.grid.addEventListener('wheel', this.onManual, { passive: true });
      this.resize = new ResizeObserver(() => this.measure());
      this.resize.observe(this.grid);
      this.measure();
    }

    measure() {
      if (!this.grid) return;
      const cards = this.grid.children;
      this.max = Math.max(0, this.grid.scrollWidth - this.grid.clientWidth);
      this.stride = cards.length > 1 ? Math.abs(cards[1].offsetLeft - cards[0].offsetLeft) : this.grid.clientWidth;
      this.rtl = getComputedStyle(this.grid).direction === 'rtl';
      this.target = null;
      this.buttons.forEach(button => { button.hidden = false; });
      this.update();
    }

    update() {
      const position = Math.abs(this.grid.scrollLeft);
      if (this.target !== null && Math.abs(position - this.target) < 2) this.target = null;
      this.buttons.forEach(button => {
        const available = this.max > 2 && (Number(button.dataset.rnfCollectionListStep) < 0 ? position > 2 : position < this.max - 2);
        const visible = this.home || available;
        button.dataset.visible = String(visible);
        button.disabled = !available;
        button.setAttribute('aria-hidden', String(!visible));
      });
    }

    stop() {
      if (!this.grid) return;
      cancelAnimationFrame(this.frame);
      this.resize.disconnect();
      this.removeEventListener('click', this.onClick);
      this.grid.removeEventListener('scroll', this.onScroll);
      this.grid.removeEventListener('pointerdown', this.onManual);
      this.grid.removeEventListener('wheel', this.onManual);
      this.buttons.forEach(button => {
        button.hidden = true;
        button.disabled = true;
        button.dataset.visible = 'false';
        button.setAttribute('aria-hidden', 'true');
      });
      this.grid = null;
    }

    disconnectedCallback() {
      this.stop();
      this.desktop?.removeEventListener('change', this.sync);
      this.desktop = null;
    }
  });
}
